(function () {
  var drawer = null;
  var body = null;
  var itemsEl = null;
  var emptyEl = null;
  var footerEl = null;
  var subtotalEl = null;
  var template = null;
  var countBubbles = [];

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function render(cart) {
    if (!itemsEl) return;
    countBubbles.forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (cart.item_count === 0) {
      emptyEl.hidden = false;
      itemsEl.innerHTML = '';
      footerEl.hidden = true;
      return;
    }

    emptyEl.hidden = true;
    footerEl.hidden = false;
    subtotalEl.textContent = money(cart.total_price, cart.currency);

    itemsEl.innerHTML = '';
    cart.items.forEach(function (item) {
      var node = template.content.cloneNode(true);
      var line = node.querySelector('[data-cart-line]');
      line.setAttribute('data-key', item.key);

      var img = node.querySelector('[data-cart-line-image]');
      if (item.image) {
        img.src = item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_200x$1$2');
        img.alt = item.product_title;
      } else {
        img.remove();
      }

      var titleEl = node.querySelector('[data-cart-line-title]');
      titleEl.textContent = item.product_title;
      titleEl.href = item.url;

      var variantEl = node.querySelector('[data-cart-line-variant]');
      if (item.variant_title) {
        variantEl.textContent = item.variant_title;
      } else {
        variantEl.remove();
      }

      var qtyEl = node.querySelector('[data-cart-line-qty]');
      qtyEl.textContent = item.quantity;

      var decreaseBtn = node.querySelector('[data-cart-line-decrease]');
      var increaseBtn = node.querySelector('[data-cart-line-increase]');

      decreaseBtn.addEventListener('click', function () {
        updateItem(item.key, item.quantity - 1);
      });

      increaseBtn.addEventListener('click', function () {
        updateItem(item.key, item.quantity + 1);
      });

      node.querySelector('[data-cart-line-price]').textContent = money(item.final_line_price, cart.currency);

      node.querySelector('[data-cart-line-remove]').addEventListener('click', function () {
        updateItem(item.key, 0);
      });

      itemsEl.appendChild(node);
    });
  }

  function refresh() {
    return fetchCart().then(render);
  }

  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { open(); });
  }

  function updateItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    refresh();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    body = drawer.querySelector('[data-cart-drawer-body]');
    itemsEl = drawer.querySelector('[data-cart-drawer-items]');
    emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
    footerEl = drawer.querySelector('[data-cart-drawer-footer]');
    subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    template = document.getElementById('CartDrawerLineTemplate');
    countBubbles = Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]'));

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
      el.addEventListener('click', open);
    });

    document.addEventListener('click', function (e) {
      var quickAdd = e.target.closest('[data-quick-add]');
      if (!quickAdd) return;
      e.preventDefault();
      var variantId = quickAdd.getAttribute('data-variant-id');
      if (!variantId) return;
      var originalText = quickAdd.textContent;
      quickAdd.disabled = true;
      quickAdd.textContent = 'Adding...';
      addItem(variantId, 1).then(function () {
        quickAdd.textContent = originalText;
        quickAdd.disabled = false;
      }).catch(function () {
        quickAdd.textContent = originalText;
        quickAdd.disabled = false;
      });
    });

    refresh();
  });

  window.VoltCart = {
    open: open,
    close: close,
    refresh: refresh,
    addItem: addItem,
    updateItem: updateItem
  };
})();